import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const TabsBarStyled = styled.nav`
  position: ${({ position }) => position};
  max-width: ${({ maxWidth }) => `${maxWidth}px`};
  margin: 0 auto;
  top: 0;
  z-index: 10;
  background-color: var(--neutral100);
  margin-top: 1em;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  .tab {
    color: #d3d3d4;
    padding: 0;
    cursor: pointer;
    background: inherit;
    border: none;
    &.is-active {
      background-color: #aeb7c10d;
      color: var(--white);
    }
  }
`

function TabsBar({
  options, tabActive, setTabActive, position, maxWidth, link,
}) {
  return (
    <TabsBarStyled position={position} maxWidth={maxWidth}>
      {
        options.map((tab) => (
          <button type="button" key={tab.id} className={`tab ${tab.id === tabActive && 'is-active'}`} onClick={() => setTabActive(tab.id)}>
            <a href={`#${link}`} id={`${link}-${tab.id}`}>
              {tab.component}
            </a>
          </button>
        ))
      }
    </TabsBarStyled>
  )
}

TabsBar.defaultProps = {
  position: 'static',
  maxWidth: 'initial',
  link: '',
}

TabsBar.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      component: PropTypes.node,
    }),
  ).isRequired,
  tabActive: PropTypes.string.isRequired,
  setTabActive: PropTypes.func.isRequired,
  position: PropTypes.string,
  maxWidth: PropTypes.number,
  link: PropTypes.string,
}

export default TabsBar
